import { useMemo } from 'react'
import { useTheme } from 'styled-components'

export const useContainerWidth = () => {
	const theme = useTheme() as {
		containerMaxWidth?: number
		minPadding?: number
	}
	return useMemo(() => {
		if (!theme?.containerMaxWidth) return 1060
		return Math.min(
			theme?.containerMaxWidth || 1040,
			document.body.clientWidth - (theme?.minPadding || 0) * 2
		)
	}, [theme?.containerMaxWidth, theme?.minPadding])
}
